import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter} from "@angular/core";
import {Observable} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import {StripeLoaderService} from "../shared/common/StripeLoaderService";


declare var $:any;
declare var swal: any;
declare var formatter: any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-result',
    templateUrl: 'result.component.html',
    styleUrls: ['result.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.RecipientRequestService, Communication.PlansService, Communication.PlansService, Communication.SubscriptionService, Communication.PaymentService, Communication.UsersService],
    standalone: false
})
export class ResultComponent implements OnInit, OnDestroy {
  subscriptions:Subscription[] = [];
  action:string="";
  plan:string="";
  period:string="";
  paymentid:string="";
  user:any;
  paymentMethod:string = Config.PAYMENT_METHOD;
  stripePaymentStatus:string = "";

  constructor(
              private activatedRoute:ActivatedRoute,
              public router:Router,
              private authorization: Authorization,
              private toolbarService: ToolbarService,
              private notificationService: NotificationService,
              public translate: TranslateService,
              private paymentApi:Communication.PaymentService,
              private usersApi: Communication.UsersService,
              private stripeLoader: StripeLoaderService)
  {


  }


  ngOnInit() {
    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {
      this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.PAYMENT_RESULT, "", null, "", "", "", "", "", ""));

      this.subscriptions.push(this.activatedRoute.queryParams.subscribe(
        (param) => {
          // Capture the token  if available
          this.action = param['action'];
          this.plan = param['plan'];
          this.period = param['period'];
          this.paymentid = param["paymentid"];

          if(this.paymentid != null){
            this.updateSubscription();
          }

          // Stripe return handling
          let paymentIntentClientSecret = param["payment_intent_client_secret"];
          if(paymentIntentClientSecret && this.paymentMethod == "STRIPE"){
            this.verifyStripePayment(paymentIntentClientSecret);
          }

          console.log("params: " + this.action + this.plan + " " + this.period);

          /*if (param['action'] === null || param['plan'] == null || param['period'] == null || param['price'] == null) {
            //TODO:ERROR
            alert("Access Denied");
          }*/
        })
      );

    }
  }

  updateSubscription(){

    this.subscriptions.push(
      this.usersApi.usersGet(
        this.authorization.getAccessToken()
      ).subscribe(
        (userResponse:any) => {
          this.user = userResponse;
          this.subscriptions.push(
            this.paymentApi.paymentsIdGet(
              this.authorization.getAccessToken(),
              this.paymentid
            ).subscribe(
              (response:any) => {
                let payment = response;
                let userSubscription = this.user.subscription;
                if(userSubscription.userId == payment.user.id && userSubscription.plan.id == payment.plan.id && userSubscription.period == payment.period){
                  console.log("Subscription updated.");
                  this.authorization.setUserAccount(userSubscription, this.authorization.userAccount.language);
                } else {
                  this.router.navigate(['/']);
                }
              },
              (error:any) => {
                console.log(error);
              }
            )
          )
        },
        (error:any) => {
          this.user = null;
        }
      )
    )

  }

  verifyStripePayment(clientSecret:string){
    this.stripeLoader.loadStripe().then(stripe => {
      return stripe.retrievePaymentIntent(clientSecret).then((result:any) => {
        if(result.paymentIntent){
          this.stripePaymentStatus = result.paymentIntent.status;
          if(result.paymentIntent.status === "succeeded"){
            this.subscriptions.push(
              this.usersApi.usersGet(
                this.authorization.getAccessToken()
              ).subscribe(
                (userResponse:any) => {
                  this.user = userResponse;
                  let userSubscription = userResponse.subscription;
                  this.authorization.setUserAccount(userSubscription, this.authorization.userAccount.language);
                },
                (error:any) => {
                  console.log(error);
                }
              )
            );
          }
        }
      });
    }).catch(() => {
      this.stripePaymentStatus = 'load_error';
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
  }
}
